import { Screenshot } from '../types';
import screen1 from "../images/Simulator Screenshot - iPhone 17 Pro - 2026-03-03 at 16.37.31.webp";
import screen2 from "../images/Simulator Screenshot - iPhone 17 Pro - 2026-03-03 at 16.37.39.webp";
import screen3 from "../images/Simulator Screenshot - iPhone 17 Pro - 2026-03-03 at 16.38.11.webp";
import screen4 from "../images/Simulator Screenshot - iPhone 17 Pro - 2026-03-03 at 16.41.39.webp";

export const screenshots: Screenshot[] = [
    { title: "Your Dishes", subtitle: "AI finds perfect recipes from your ingredients", image: screen2 },
    { title: "Recipe Detail", subtitle: "Step-by-step with cost comparison", image: screen1 },
    { title: "Cooking Insights", subtitle: "Track activity & money saved", image: screen3 },
    { title: "AI Ingredient Search", subtitle: "Enter what you have, get a meal plan", image: screen4 },
];
